export default __webpack_public_path__ + "static/media/ongoing5.87cde480.png";